import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, InputGroup, Row, Spinner } from 'react-bootstrap';
import { useGetDta } from '../../hooks/useGetDta';
import { useContextInfo } from '../../context/ContextInfo';
import { useForm } from '../../hooks/useForm';
import { fetchConToken } from '../../api/fetch';
import LoadinSpin from '../ui/LoadinSpin';
import op from '../../images/openpay.png';

const OpenPayp = () => {
    const { loading, data, getInfo } = useGetDta('main/pasarela/openpay');
    const { setResp } = useContextInfo();
    const [send, setsend] = useState(false);
    const [validated, setValidated] = useState(false);

    const [enable, setEnable] = useState(false);
    const [sandbox, setSandbox] = useState(false);
    const [values, handleInputChange, reset, setFormValue] = useForm({
        nombre: 'openpay',
        idm: '',
        key_public: '',
        key_private: '',
        webhook: '',
    });
    useEffect(() => {
        if (data.id) {
            setEnable(data.enable);
            setSandbox(data.sandbox);
            setFormValue({ ...values, ...data });
        }
    }, [data]);

    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setsend(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken(`main/pasarela`, { ...values, enable, sandbox }, 'POST');
            setResp(res);
        }
        setsend(false);
    };
    if (loading) return <LoadinSpin />;
    return (
        <Col md="auto" className="  shadow-none  mb-5 bg-body-tertiary rounded ">
            <Card>
                <Card.Img variant="top" className="text-center" src={op} />

                <Card.Body>
                    <Form noValidate onSubmit={onSubmit} validated={validated}>
                        <Col>
                            {' '}
                            <Form.Group className="mb-3" controlId="validationCustom17">
                                <Form.Label>Id</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={values.idm}
                                    name="idm"
                                    required
                                    onChange={handleInputChange}
                                />
                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                            </Form.Group>{' '}
                        </Col>
                        <Col>
                            {' '}
                            <Form.Group className="mb-3" controlId="validationCustom17">
                                <Form.Label>KEY Privada </Form.Label>
                                <Form.Control
                                    type="text"
                                    value={values.key_private}
                                    name="key_private"
                                    required
                                    onChange={handleInputChange}
                                />
                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                            </Form.Group>{' '}
                        </Col>
                        <Col>
                            {' '}
                            <Form.Group className="mb-3" controlId="validationCustom17">
                                <Form.Label>KEY Publica </Form.Label>
                                <Form.Control
                                    type="text"
                                    value={values.key_public}
                                    name="key_public"
                                    required
                                    onChange={handleInputChange}
                                />
                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                            </Form.Group>{' '}
                        </Col>
                        <Col>
                            {' '}
                            <Form.Group className="mb-3" controlId="validationCustom17">
                                <Form.Label>Url Webhook</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={values.webhook}
                                    name="webhook"
                                    onChange={handleInputChange}
                                />
                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                            </Form.Group>{' '}
                        </Col>

                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="validationCustom17">
                                    <InputGroup>
                                        <Form.Check
                                            type="switch"
                                            id="custom-switch"
                                            label="Modo sandbox"
                                            checked={sandbox}
                                            onChange={() => setSandbox(!sandbox)}
                                        />
                                    </InputGroup>
                                </Form.Group>{' '}
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="validationCustom17">
                                    <InputGroup>
                                        <Form.Check
                                            type="switch"
                                            id="custom-switch"
                                            label="Activar"
                                            checked={enable}
                                            onChange={() => setEnable(!enable)}
                                        />
                                    </InputGroup>
                                </Form.Group>{' '}
                            </Col>
                        </Row>

                        {send ? (
                            <Button color="primary" disabled>
                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                Guardando...
                            </Button>
                        ) : (
                            <Button type="submit">Guardar cambios</Button>
                        )}
                    </Form>{' '}
                </Card.Body>
            </Card>
        </Col>
    );
};

export default OpenPayp;
